module.exports = "https://static.wmbcdn.com/uniweb/images/78443f569bfb36bc97de565c77d54e0f.svg";